/* unplugin-vue-components disabled */import { render } from "./pulse-category.vue?vue&type=template&id=b88f5f28&scoped=true"
import script from "./pulse-category.vue?vue&type=script&lang=js"
export * from "./pulse-category.vue?vue&type=script&lang=js"

import "./pulse-category.vue?vue&type=style&index=0&id=b88f5f28&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b88f5f28"],['__file',"src/pages/pulse/pulse-category.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b88f5f28"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b88f5f28', __exports__)) {
    api.reload('b88f5f28', __exports__)
  }
  
  module.hot.accept("./pulse-category.vue?vue&type=template&id=b88f5f28&scoped=true", () => {
    api.rerender('b88f5f28', render)
  })

}


export default __exports__